import React from 'react';
import Icon from '@/components/ui/AppIcon';

type Channel = 'PHONE' | 'WHATSAPP' | 'LIVE CHAT' | 'EMAIL' | 'WEB CHAT' | 'GOVCHAT';

const channelConfig: Record<Channel, { cls: string; icon: string; label: string }> = {
  'PHONE': { cls: 'channel-badge-voice', icon: 'PhoneIcon', label: 'Phone' },
  'WHATSAPP': { cls: 'channel-badge-whatsapp', icon: 'ChatBubbleOvalLeftEllipsisIcon', label: 'WhatsApp' },
  'LIVE CHAT': { cls: 'channel-badge-livechat', icon: 'ChatBubbleLeftRightIcon', label: 'Live Chat' },
  'EMAIL': { cls: 'channel-badge-email', icon: 'EnvelopeIcon', label: 'Email' },
  'WEB CHAT': { cls: 'channel-badge-webchat', icon: 'GlobeAltIcon', label: 'Web Chat' },
  'GOVCHAT': { cls: 'channel-badge-govchat', icon: 'BuildingOfficeIcon', label: 'GovChat' },
};

interface ChannelBadgeProps {
  channel: Channel;
  showLabel?: boolean;
}

export default function ChannelBadge({ channel, showLabel = true }: ChannelBadgeProps) {
  const cfg = channelConfig[channel] || channelConfig['PHONE'];
  return (
    <span className={`inline-flex items-center gap-1 rounded text-[11px] font-600 px-1.5 py-0.5 ${cfg.cls}`}>
      <Icon name={cfg.icon as Parameters<typeof Icon>[0]['name']} size={10} />
      {showLabel && cfg.label}
    </span>
  );
}